<ng-container *ngIf="organisation">
    <acabim-card cardHeading="Request Trial Seat" [isCollapsible]="false" [cardContent]="requestResource"></acabim-card>

    <ng-template #requestResource>
        <form [formGroup]="subscriptionRequestForm" class="m-1">
            <div class="p-fluid p-formgrid cas-flex-row">
                <div class="p-field p-col-12 p-md-4">
                    <label for="resource-type">Resource Type</label>
                    <p-dropdown id="resource-type" inputId="resource-type" [options]="availableResources" formControlName="resourceType"
                                optionLabel="name"></p-dropdown>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label for="num-of-resources">Add/Remove Resources</label>
                    <p-inputNumber id="num-of-resources" pInputText formControlName="numberOfResources" [showButtons]="true"></p-inputNumber>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    Total: {{finalCount}}
                </div>
            </div>
            <button (click)='request()' class="cas-button-action mb-4" [disabled]="finalCount <= 0">Request</button>
        </form>
    </ng-template>
</ng-container>

<p-toast position="top-right" key="subscription-create-request"></p-toast>
